import { useQuery } from '@tanstack/react-query';

import { cartQuery } from './cartQuery';

export const useCart = () => useQuery(cartQuery());
